import { SiteIntegration, UserIdentity } from "~/api/Api";

import {
  InferResolvedRecordType,
  MemberAuthorizationsResolver,
} from "../../../helpers/MemberAuthorizationsResolver";

export const WITH_AUTHORIZATIONS = {
  USER_IDENTITIES: new MemberAuthorizationsResolver<UserIdentity, "destroy">([
    "destroy",
  ]),
  SITE_INTEGRATIONS: new MemberAuthorizationsResolver<
    SiteIntegration,
    "configuration" | "destroy" | "update"
  >(["configuration", "destroy", "update"]),
};

export type UserIdentityWithAuthorizations = InferResolvedRecordType<
  typeof WITH_AUTHORIZATIONS.USER_IDENTITIES
>;

export type SiteIntegrationWithAuthorizations = InferResolvedRecordType<
  typeof WITH_AUTHORIZATIONS.SITE_INTEGRATIONS
>;
